'use client';

import { Media } from '@backbone-one/contentful-client';
import { HeroUIProvider, ToastProvider } from '@heroui/react';
import CustomizationsProvider from './customizations-provider';

export function Providers({
  children,
  customizations,
}: {
  children: React.ReactNode;
  customizations: Record<string, Media>;
}) {
  return (
    <CustomizationsProvider customizations={customizations}>
      <HeroUIProvider>
        <ToastProvider maxVisibleToasts={1} toastProps={{ timeout: 20000 }} />
        {children}
      </HeroUIProvider>
    </CustomizationsProvider>
  );
}
